import { userStore } from '@user';
import { useRecoilValue } from 'recoil';

export const useCurrentRole = () => {
  return useRecoilValue(userStore.roleSelector);
};
